import { PageMessage } from '@change-corgi/design-system-legacy/components/alerts';

import { usePageBanner } from './hooks/usePageBanner';

export function PageBanner() {
	const { data, actions } = usePageBanner();

	if (!data.banner) return null;

	return (
		<PageMessage
			id="petition-edit-banner"
			role="alert"
			data-qa="edit-success-banner"
			dismissable={data.banner.dismissable}
			primaryAction={data.banner.primaryAction}
			severity={data.banner.severity}
			message={data.banner.message}
			onClose={actions.onDismiss}
			sx={{ position: 'sticky', top: 0, zIndex: 6 }}
		/>
	);
}
